import './styles/NetworkVersionController.scss';

import { Fragment, useState, useEffect, useContext } from 'react';
import { Network } from '@capacitor/network';
import { AppContext } from '../Context';
import axios from 'axios';
import { Browser } from '@capacitor/browser';
import { isPlatform } from '@ionic/react';
import { useLocation } from 'react-router';

//controllers
import DatabaseInterfaceController from '../controllers/DatabaseInterfaceController';


interface Props {
    dburl: string, secret: string, appLink: any, appBuild: string,
    shouldCheckNetwork: boolean,
    shouldForceUpdateApp: boolean,
    SetPopupMessage: any, SetPopupButtons: any, SetPopupActions: any
}

const NetworkVersionController: React.FC<Props> = ({ dburl, secret, appLink, appBuild, shouldCheckNetwork, shouldForceUpdateApp, SetPopupMessage, SetPopupButtons, SetPopupActions }) => {
    //context
    const appContext = useContext(AppContext);
    //states
    const [internetConnection, SetInternetConnection] = useState<boolean | null>(null);
    //const [appBuild, SetAppBuild] = useState(''); --attempt deprecate
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);
    //router objs
    const location = useLocation();

    //watchers
    useEffect(() => {
        if (shouldCheckNetwork) {
            //check initial network status
            Network.getStatus().then((status) => {
                SetInternetConnection(status.connected);
            });
            //keep watch on network status change
            Network.addListener('networkStatusChange', (status) => {
                console.log('networkStatusChanged: ' + JSON.stringify(status));
                SetInternetConnection(status.connected);
            });
        }

        if (shouldForceUpdateApp) {
            FetchAppBuildFromServer(); //---turn  on after setting backend
        }
    }, []);

    useEffect(() => {
        console.log('checkShouldCheckNetwork: ' + shouldCheckNetwork);
        if (
            location.pathname != '/Splash'
            && location.pathname != '/'
            && shouldCheckNetwork) {
            if (!internetConnection) {
                setTimeout(() => {
                    appContext.SetWaitScreenMessage('Waiting For Internet Connection');
                    appContext.SetWaitScreenShouldShow(true);
                }, 500);
            } else {
                setTimeout(() => {
                    appContext.SetWaitScreenShouldShow(false);
                }, 1000);
            }
        }
    }, [shouldCheckNetwork, internetConnection]);

    //watch for databaseActionMode and databaseResultActions
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchAppBuild':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObj = {} as any;
                            try {
                                resObj = JSON.parse(res) as any;
                            } catch {
                                resObj = res as any;
                            }
                            if (isPlatform('android') || isPlatform('mobileweb')) {
                                if (parseInt(appBuild) < parseInt(resObj.play_store_build))
                                    LoopUpdatePrompt();
                            } else if (isPlatform('ios')) {
                                if (parseInt(appBuild) < parseInt(resObj.app_store_build))
                                    LoopUpdatePrompt();
                            }
                        } else {
                            console.log('fetchAppBuildErr: ' + res);
                        }
                        break;
                }
            };

            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchAppBuild':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //app update management
    const FetchAppBuildFromServer = async () => {
        // const formData = new FormData();
        // formData.append('s3cr3t', secret);
        // formData.append('fetchAppBuild', 'true');
        // await axios.post(dburl + 'appControl.php', formData, { withCredentials: false })
        //     .then((res) => {
        //         console.log('checkAppBuild: ' + JSON.stringify(res));
        //         if (!JSON.stringify(res.data).includes('false')) {
        //             const appBuildOnServer = res.data;
        //             if(isPlatform('android') || isPlatform('mobileweb')) {
        //                 if(parseInt(appBuild) < parseInt(appBuildOnServer.play_store_build))
        //                     LoopUpdatePrompt();
        //             } else if(isPlatform('ios')) {
        //                 if(parseInt(appBuild) < parseInt(appBuildOnServer.app_store_build))
        //                     LoopUpdatePrompt();
        //             }
        //             // else if (appBuildOnServer < appBuild) {
        //             //     SyncAppBuildOnServer();
        //             // } --disable auto sync server build, use manual update
        //         }
        //     }).catch((err) => {
        //         console.log('FetchAppBuildFromServerErr: ' + err);
        //     });s

        databaseInterfaceController.Queue('fetchAppBuild', [
            ['fetchAppBuild', 'true']
        ]);
    }
    // const SyncAppBuildOnServer = async () => {
    //     const formData = new FormData();
    //     formData.append('s3cr3t', secret);
    //     formData.append('setAppBuild', 'true');
    //     formData.append('appBuild', appBuild);
    //     await axios.post(dburl + 'appControl.php', formData, { withCredentials: false })
    //         .then((res) => {
    //             if (JSON.stringify(res.data).includes('false'))
    //                 console.log('SyncAppBuildOnServerErr: ' + res.data);
    //         }).catch((err) => {
    //             console.log('SyncAppBuildOnServerErr: ' + err);
    //         });
    // } ---deprecated
    const ProceedToUpdateApp = async () => {
        let devicePlatform;
        if (/Android/i.test(window.navigator.userAgent)) {
            devicePlatform = 'android';
        } else if (/iPhone/i.test(window.navigator.userAgent)) {
            devicePlatform = 'ios';
        } else {
            devicePlatform = 'others';
        }
        await Browser.open({ url: appLink[devicePlatform as keyof typeof appLink] });
    }

    //exe function
    const LoopUpdatePrompt = () => {
        SetPopupMessage('New Version Available,\nProceed To Update App Now');
        SetPopupButtons(['ok']);
        SetPopupActions([() => {
            setTimeout(() => { LoopUpdatePrompt() }, 1000);
            ProceedToUpdateApp();
        }]);
    }

    return (
        <Fragment>
            {/*<div className='NetworkVersionController'>
            //     <span className='build-label'>build:&nbsp;{appBuild}</span>
            // </div> */}
        </Fragment>
    );
}
export default NetworkVersionController;